// extracted by mini-css-extract-plugin
export default {"resizeHandle":"ElementResizer_resizeHandle__fN62o"};